function openNav() {
    document.getElementById("main").style.marginLeft = "250px";
    document.getElementById("mySidenav").style.width = "250px";
}

function closeNav() {
    document.getElementById("mySidenav").style.width = "0";
    document.getElementById("main").style.marginLeft= "0";
}

$(document).on('click', '.js-open-nav', function() {
    openNav()
})
$(document).on('click', '.js-close-nav', function() {
    closeNav()
})